import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Volume2, VolumeX } from 'lucide-react';

const LINKS = [
  ['Services', 'services'],
  ['Values', 'values'],
  ['Work', 'portfolio'],
  ['Process', 'process'],
];

export default function Header({ onNav, muted, onToggleSound }) {
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 40);
      setHidden(y > last && y > 300);
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: hidden ? -100 : 0 }}
      transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 w-full z-[70] transition-colors duration-500 ${
        scrolled ? 'bg-white/60 backdrop-blur-xl border-b border-black/5' : ''
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          onClick={() => onNav('hero')}
          className="serif italic text-2xl tracking-tight"
          data-testid="logo-home"
        >
          RaufMedia
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              onClick={() => onNav(id)}
              className="font-sans text-xs uppercase tracking-[0.2em] text-obsidian/70 hover:text-obsidian transition-colors duration-300"
              data-testid={`nav-${id}`}
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onToggleSound}
            aria-label={muted ? 'Unmute ambient sound' : 'Mute ambient sound'}
            className="w-10 h-10 rounded-full border border-black/10 flex items-center justify-center hover:border-black/40 transition-colors duration-300"
            data-testid="sound-toggle"
          >
            {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
          </button>
          <button
            onClick={() => onNav('contact')}
            className="px-6 py-3 rounded-full bg-signal text-bone font-sans text-xs uppercase tracking-[0.2em] hover:bg-obsidian transition-colors duration-300"
            data-testid="header-contact-cta"
          >
            Contact
          </button>
        </div>
      </div>
    </motion.header>
  );
}
